<template>
  <div class="seomain">
    <st-header
      title="采购订单"
      :back-able="true"
			:more-op="[{ val: 'download', title: '下载采购单' }, { val: 'startbatch', title: '批量处理' }]"
			@command="headercommand"
    >
      <template slot="header-right">
        <span @click="addOrder()">
          <i class="el-icon-circle-plus"></i>
        </span>
				
      </template>
    </st-header>
    <ul class="tab-tilte">
      <li
        v-for="(title, index) in tabTitle"
        @click="
          changeActiveIndex(index);
          getPurlist(index);
        "
        :class="{ active: cur == index }"
        class="text-center"
        :key="index"
      >
        <span>{{ title }}</span>
      </li>
      <div class="cl"></div>
    </ul>

    <div class="tab-content tab-content-list">
      <div class="st-list-box pan-1">
          <van-list
            v-model="loading"
            :finished="finished"
            error-text="点击重新加载"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div class="st-list" v-for="(v, k) in purList[cur]" :key="k" :index="k">
                <div class="st-list-top">
                  <div class="t-tit">{{ v.code }}</div>
                  <div class="t-status">{{ tabTitle[cur] }}</div>
                </div>
                <div class="st-list-main"
									@touchstart="touchstart"
									@touchmove="touchmove"
									@touchend="touchend"
									@click="checkItem(v.id)"
								>
									<div class="list-checkbox" v-if="touchLong">
										<!-- <van-checkbox :model="checkList[v.id]"></van-checkbox> -->
										<van-checkbox :value="checkList[v.id]"></van-checkbox>
									</div>
                  <p>采购类型：{{ v.style }}</p>
                  <p>供 应 商：{{ v.suppliername }}</p>
                  <p v-if="cur == 2" style="color: red;">待 入 库：{{ v.total_storageing }}</p>
                  <p>物 流 方：{{ v.purchasingtracking }}</p>
                  <p>物流单号：{{ v.shipmentnumber }}</p>
                  <p>采 购 人：{{ v.operatorname }}</p>
                  <p v-if="[0, 1].includes(cur)">预计到货时间：{{ v.deliverytime }}</p>
                </div>
                <div v-if="cur == 0">
                  <p class="st-list-bottom st-list-bottom-2">
                    <van-button type="info" @click="editOrder(v.id)">编辑订单</van-button>
										<van-button type="primary" @click="upinvoice(v.id)">上传发票</van-button>
                    <van-button color="grey" @click="openApproveInfo(v.id)">查看订单</van-button>
                    <van-button color="orange" type="success" @click="submitApproval(v.id)">提交审核</van-button>
                  </p>
                </div>
                <div v-if="cur == 1">
                  <p class="st-list-bottom st-list-bottom-3">
                    <van-button type="info" @click="openApproveDetail(v.id)">查看审批详情</van-button>
                    <van-button color="grey" @click="openApproveInfo(v.id)">查看订单详情</van-button>
										<van-button type="primary" @click="upinvoice(v.id)">上传发票</van-button>
                  </p>
                </div>
                <div v-else-if="cur == 2" class="st-list-bottom">
                  <p
                    class="st-opt-btn"
                    @click="
                      activeId = v.id;
                      enterStore(v.id);
                    "
                    style="background-color: rgb(0, 186, 173);border-radius: 5px;"
                  >
                    入库
                  </p>
									
									
                </div>
                <!-- <div v-else-if="cur == 2" class="st-list-bottom">
                  <p
                    class="st-opt-btn"
                    @click="
                      activeId = v.id;
                      enterStore(v.id);
                    "
                    style="background-color: rgb(42, 130, 228);border-radius: 5px;"
                  >
                    入库
                  </p>
                </div> -->
                <div v-else-if="cur == 3" class="st-list-bottom">
                  <p
                    class="st-opt-btn"
                    @click="
                      activeId = v.id;
                      openApproveInfo(v.id);
                    "
                    style="background-color: rgb(103,117,136);border-radius: 5px;"
                  >
                    查看
                  </p>
                </div>

                
            </div>
          </van-list>
      </div>
			<batch-btn
				v-if="touchLong"
				:options="batchBtnOptions[cur]"
				@command="batchCommand"
			></batch-btn>
    </div>
		<upinvoice v-if="showUpinvoice" :visiable.sync="showUpinvoice" :id="act_id"></upinvoice>
  </div>
</template>

<script>
import StHeader from "@/components/layout/Header.vue";
import BatchBtn from "@/components/layout/BatchBtn.vue";
import upinvoice from "@/views/Sto/purchase/upinvoice.vue";
export default {
components: {
  "st-header": StHeader,
	'batch-btn': BatchBtn,
	upinvoice
},
props: {},
inject: ['reload'],
data() {
  return {
    tabTitle: ["待审核", "审核中", "待入库", "已入库"],
		tabs: {
			'待审核': { type: 0 },
			'审核中': { type: 1 },
			'待入库': { type: 2 },
			'已入库': { type: 3 },
		},
    cur: 0,
    purList: [
      [{  }],
    ],

    loading: false,
    finished: false,
    page: 1,
		
		checkList: {},
		batchBtnOptions: {},
		touchLong: false,
		showUpinvoice: false,
		
		act_id: '',
  };
},
watch: {
  	touchLong: function(nv, ov) {
  		this.checkList = {};
  		this.$forceUpdate();
  	}
  },

methods: {
  init() {
    if (this.$route.params.status) this.cur = this.$route.params.status;
    this.getPurlist();
		this.setBatchBtnOption();
  },
  
  // 更改标签
  changeActiveIndex(value) {
    if (value === this.cur) return;
		this.touchLong = false;
    this.cur = value;
    this.$router.replace(`/purchase/list/${value}`);
  },

  // 获取采购单列表
  getPurlist() {
    this.purList = this.tabTitle.map(() => { return [] });

    this.page = 1;
    this.loading = true;
    this.finished = false;
    this.onLoad();
  },

  // 分页
  async onLoad() {
    let result = await this.$post(this.$api.stPurchaseList, {
      order_code: this.order_code,
      status: this.cur,
      page: this.page,
      sku: this.sku,
    });

    if (!result.data.list || result.data.list.length == 0) return (this.finished = true);

    // 进行操作
    this.purList[this.cur].push(...result.data.list);
    // 操作完成
    this.page += 1;
    this.loading = false;
  },

  // 添加订单
  addOrder() {
    this.$router.push(`/purchase/add`);
  },

  // 编辑订单
  editOrder(id) {
    this.$router.push(`/purchase/edit/${id}`);
  },

  // 查看审批详情
  openApproveDetail(id = 1) {
    this.$router.push(`/purchase/approveDetail/${id}`);
  },

  // 查看订单详情
  openApproveInfo(id = 1) {
    let pur = this.purList[this.cur].find((item) => { return item.id === id; } );
    this.$router.push(`/purchase/info/${id}?code=${pur['code']}`);
  },

  // 入库 跳转
  enterStore(id) {
    this.$router.push(`/purchase/enterStore/${id}`);
  },
	
	// 上传发票
	upinvoice(id) {
		this.act_id = id;
		this.showUpinvoice = true;
	},

  // 提交审核
  submitApproval(id) {
    this.$post(this.$api.stPurchaseApproval, {id: id}).then((res) => {

      if (res.code == 200) {
        this.$toast.success('提交成功');
        let purIndex = this.purList[this.cur].findIndex((item) => {  console.log('fclit', item); return item.id == id; });

        this.purList[this.cur].splice(purIndex, 1);
      } else if (res.code === 0) {
        this.$toast.fail(res['msg'] ? res['msg'] : '提交异常');
      } else {
        this.$toast.fail('提交异常');
      }
    });

    
  },

	// #region-start 批量操作相关方法
	// 开始触屏
	touchstart() {
		this.touchTimeOut = setTimeout(() => {
			this.touchLong = true;
		}, 2500)
	},
	touchmove() {
		clearTimeout(this.touchTimeOut);
	},
	touchend() {
		clearTimeout(this.touchTimeOut);
	},
	
	// 勾选
	checkItem(id) {
		this.checkList[id] = !this.checkList[id];
		this.$forceUpdate();
	},
	getCheckIds() {
		let ids = [];
		for (let i in this.checkList) {
			if (this.checkList[i]) {
				ids.push(i);
			}
		}
		
		return ids;
	},
	
	// #region start 操作采购单
	del(ids) {
		this.$confirm('您正在进行删除操作，数据删除后将无法找回，是否要继续进行？').then((res) => {
			// 删除
			this.$post(this.$api.stPurchaseOrderDel, {ids: ids}).then((res) => {
				if (res.code == 1) {
					this.$toast.success('删除成功');
					this.reload();
				} else {
					this.$toast.fail(res.msg ? res.msg : '删除失败');
				}
			}).catch((err) => {
				this.$toast.fail(err);
			});
		}).catch((err) =>  {
			console.log('您取消了删除操作')
		})
	},
	
	// 通过审核 以及 已入库  撤回
	returnorder(ids) {
		this.$confirm('您正在进行撤回操作，是否要继续进行？').then((res) => {
			this.$post(this.$api.stPurhchaseReturnOrder, {ids: ids}).then((res) => {
				if (res.code == 1) {
					this.$toast.success('撤回成功');
					this.reload();
				} else {
					this.$toast.fail(res.msg ? res.msg : '撤回失败');
				}
			}).catch((err) => {
				this.$toast.fail(err);
			});
		}).catch((err) =>  {
			console.log('您取消了撤回操作')
		})
	},
	// #region end 
	
	// 设置 批量操作的按钮
	setBatchBtnOption() {	
		let options = {};
		let oprator = {
			"contract": { text: '采购合同', value: 'genePurchaseContract' },
			"del": { text: '删除', value: 'delPurchase' },
			"return": { text: '撤回', value: 'returnOrder' },
		};
		let option = [
			{ text: '操作', children: [],
			}
		];
		
		for(let tit in this.tabs) {
			let v = this.tabs[tit];
			let children = [];
			if (v.type == 0) {
				options[v.type] = JSON.parse(JSON.stringify(option));
				children = ['del'];
			}  else if (v.type == 1) {
				
			} else if (v.type == 2) {
				options[v.type] = JSON.parse(JSON.stringify(option));
				children = ['contract', 'return'];
			} else if (v.type == 3) {
				options[v.type] = JSON.parse(JSON.stringify(option));
				children = ['contract', 'return'];
			}
		
			children.forEach((child) => {
				if (options[v.type]) {
					options[v.type][0].children.push(oprator[child]);
				}
				
			})
		}
		this.batchBtnOptions = options;
	},
	openMoreop() {
		this.showMoreOp = true;
	},
	headercommand(val) {
		this[val]();
	},
	/**
	 * 下载采购单
	 */
	async download() {
		let params = {
			order_code: this.order_code,
			status: this.cur,
			sku: this.sku,
			// d_token: window.localStorage.getItem("sto_user_token"),
		}

		await this.$post(this.$api.stPurchaseDownload, params).then((res) => {
			window.location.href = res.data;
		})
		
		
		// let tempArray = [];
		// for (const item in params) {
		// 	if (params[item] !== undefined && item) {
		// 		tempArray.push(`${item}=${params[item]}`);
		// 	}
		// }
		// let url = `${this.$api.stPurchaseDownload}?${tempArray.join('&')}`;
		// this.$downFile(this.$api.stPurchaseDownload,params,{},'采购单.xlsx').then((res) => {})
	},
	
	// 开启批量模式
	startbatch() {
		this.touchLong = true;
	},
	
	// 批量处理
	batchCommand(sign, params) {
		if (sign == 'cancel') {
			this.touchLong = false;
			return;
		}
		
		let checkedIds = this.getCheckIds();
		if (!checkedIds || Object.keys(checkedIds).length <= 0) {
			this.$toast.fail('请选择采购单');
			return;
		}
	
		// 生成采购合同
		if (sign == 'genePurchaseContract') {
			this.$post(this.$api.stPurchaseGeneContract, {ids: checkedIds}).then((res) => {
				// let route = "/pdf/" + encodeURIComponent(res.data);
				// this.goUrl(route);
				if (res.code === 1) {
						window.location.href = res.data;
				} else {
					this.$toast.fail(res.msg);
				}
				
			}).catch((err) => {
				console.log(err)
			});
		} else if (sign == 'delPurchase') {
			this.del(checkedIds);
			return;
		} else if (sign == 'returnOrder') {
			this.returnorder(checkedIds);
			return;
		}
	},
	// #region-edn 批量操作相关方法
	
},
created() {
  this.init();
  window.h5sdk && window.h5sdk.ready(function() {
    window.h5sdk.biz.navigation.setTitle({ title: "采购价格维护" });
  });
},
mounted() {
},
};
</script>

<style lang="scss" scoped>
.st-header-right {
  .el-icon-circle-plus {
    font-size: 30px;
    transform: translateY(7px);
    color: rgba(42, 130, 228, 1);
  }
}

.tab-tilte {
  display: flex;
  overflow-x: auto;
  li {
    width: auto;
    min-width: 88px;
    flex: 1 0 88px;
  }
}

.tab-content-list {
  padding-top: 50px;
  .pan-1 { 
    .t-tit {
      padding-left: 2px;
      font-size: 16px;
      border-left-color: #3eb399;
    }
    .t-status {
      font-size: 15px;
      color: #3eb399;
    }
    .st-list-bottom-2,.st-list-bottom-3 {
      background-color: white;
      display: flex;
			flex-wrap: wrap;
      justify-content: space-between;
      width: 100%;
    }

    .st-list-bottom-2 {
      .van-button {
				margin-top: 8px;
        width: 45%;
        border-radius: 8px;
      }
    }

    .st-list-bottom-3 {
      .van-button {
        width: 30%;
        border-radius: 8px;
      }
    }
  }
}
.two li {
  width: 50%;
}

.st-list-main {
	position: relative;
	.list-checkbox {
		position: absolute;
		top: 10px;
		right: 20px;
	}
}

.tab-content .st-list {
	margin: 16px 18px;
	border-radius: 5px;
}

.page-more{
	position: fixed;
	background-color: white;
	z-index: 9999;
	width: 100px;
	text-align: left;
	padding-top: 8px;
	right: 2px;
	border-radius: 5px;
	box-shadow: 0px 1px 3px 0px	;
	padding-bottom: 3px;
}

.page-more li {
	padding: 5px 8px;
}
</style>
